<div class="overflow-y-auto h-[85vh] mx-5 mb-5 pr-5 mr-0">

	<!-- <button (click)="updateStats()" class="h-32 w-full bg-red-200 text-center
	
	
	">ok oko okok okoko, okokoko okopkpa fl, akef,kmaze ,lze ,klmze fklmze,f klmazf, komqzern fozel,faeril</button> -->
	<div class="bg-white rounded-2xl ">
		<span class="join gap-2 relative w-full">
			<app-dashboard-page-header [platformName]="'google'" (selectedDateRange)="updateStats($event)" [hasNoPages]="googlePageIds.length==0 && !isInsightsLoading"/>
		</span>
	</div>
	<div class=" bg-white my-5 py-2 rounded-xl px-5">
		<h3 class="font-bold py-4 text-xl block" [ngClass]="{'animate-pulse':isInsightsLoading && googlePageIds.length>0}">{{'pageInsights.labels.general'|translate}}</h3>
		<div class="flex flext-wrap gap-2 w-full pb-3" >
			<app-widget-stats *ngFor="let item of GetGeneralData()" class=" w-[20%] " [data]="item" [source]="'google'" [isLoading]="isInsightsLoading && googlePageIds.length>0" />
		</div>
	</div>
	<div class="flex flex-wrap gap-4 w-full">
		<div class="bg-white py-2 rounded-xl w-[calc(50%-0.5rem)] px-5">
			<h3 class="font-bold py-4 text-xl block" [ngClass]="{'animate-pulse':isInsightsLoading && googlePageIds.length>0}">{{'pageInsights.labels.views' | translate}}</h3>
			<div class="flex justify-between items-center mb-6 mx-2 py-5 shadow-[0_-0.5px_1.5px_rgba(0,0,0,0.025),_0_4px_6px_rgba(0,0,0,0.1)] p-2 rounded-xl" [ngClass]="{'animate-pulse':isInsightsLoading &&  googlePageIds.length>0}">
			  <div class="flex items-center">
					<div class="bg-red-50 text-[#ea580c] rounded-full w-10 h-10 flex items-center justify-center">
						<app-svg-palette [icon]="'eye'"/>
					</div>
					<p class="text-sm font-semibold text-[#777171] ml-2 mr-1">{{viewsEstablishmentProfile?.label | translate}}</p>
					<div class=" ml-1">
							<app-tool-tip [Text]="viewsEstablishmentProfile?.tooltip | translate" [toolTipClass]="'tooltip-position-bottom'"/>
									
       		</div>
			  </div>
			  <p class="text-3xl mr-4 text-gray-600 font-semibold">{{viewsEstablishmentProfile?.value|kMNotation}}</p>
			</div>
			<div class="flex justify-between" [ngClass]="{'animate-pulse':isInsightsLoading && googlePageIds.length>0}">
			  <div class="w-1/2 pr-2">
				<h3 class="text-sm font-medium mb-4">{{'pageInsights.google.googleSearch' | translate}}</h3>
				<div class="mx-2 flex items-center h-12 shadow-[0_-0.5px_1.5px_rgba(0,0,0,0.025),_0_4px_6px_rgba(0,0,0,0.1)] px-2 rounded-xl mb-5">
				  <span class="w-2 h-2 bg-cliking_blue rounded-full mr-2"></span>
				  <p class="text-sm">{{'pageInsights.google.mobile' | translate}}</p>
				  <span class="ml-auto text-sm font-medium">{{googleSearchMobile?.value|kMNotation}}</span>
				</div>
				<div class="mx-2 flex items-center h-12 shadow-[0_-0.5px_1.5px_rgba(0,0,0,0.025),_0_4px_6px_rgba(0,0,0,0.1)] px-2 rounded-xl">
				  <span class="w-2 h-2 bg-cliking_yellow rounded-full mr-2"></span>
				  <p class="text-sm">{{'pageInsights.google.desktop'| translate}}</p>
				  <span class="ml-auto text-sm font-medium">{{googleSearchDesktop?.value|kMNotation}}</span>
				</div>
			  </div>
			  <div class="w-1/2 pl-2">
				<h3 class="text-sm font-medium mb-4">{{'pageInsights.google.googleMapsSearch' | translate}}</h3>
				<div class="mx-2 flex items-center h-12 shadow-[0_-0.5px_1.5px_rgba(0,0,0,0.025),_0_4px_6px_rgba(0,0,0,0.1)] px-2 rounded-xl mb-5">
				  <span class="w-2 h-2 bg-cliking_red rounded-full mr-2"></span>
				  <p class="text-sm">{{'pageInsights.google.mobile' | translate}}</p>
				  <span class="ml-auto text-sm font-medium">{{googleMapsSearchMobile?.value|kMNotation}}</span>
				</div>
				<div class="mx-2 flex items-center h-12 shadow-[0_-0.5px_1.5px_rgba(0,0,0,0.025),_0_4px_6px_rgba(0,0,0,0.1)] px-2 rounded-xl">
				  <span class="w-2 h-2 bg-cliking_green rounded-full mr-2"></span>
				  <p class="text-sm">{{'pageInsights.google.desktop'| translate}}</p>
				  <span class="ml-auto text-sm font-medium">{{googleMapsSearchDesktop?.value|kMNotation}}</span>
				</div>
			  </div>
			</div>
		</div>
		<div class="bg-white py-2 rounded-xl w-[calc(50%-0.5rem)] pb-5 px-5">
			<h3 class="font-bold py-4 text-xl block" [ngClass]="{'animate-pulse':isInsightsLoading && googlePageIds.length>0}">{{'pageInsights.labels.commercialEngagement' | translate}}</h3>
			<div class="w-[100%] flex flex-wrap gap-2">
				<app-widget-stats *ngFor="let item of GetCommercialEngagementData()" class="w-[calc(50%-0.5rem)]" [data]="item" [source]="'google'" [isLoading]="isInsightsLoading && googlePageIds.length>0" />
			</div>
		</div>
	</div>
	
	<!-- filtred posts -->
	 <!-- <span class="text-xs"><pre>{{data|json}}</pre></span> -->
	<div *ngIf="googlePageIds.length>0" class="bg-white h-[82vh] my-5 py-5 relative flex items-end rounded-2xl">
		<div class="rounded-2xl h-[80vh] overflow-hidden absolute w-full">
			<app-posts-library  [dashboard]="true" [dashboardSource]="'google'" [currentPostsTypeFilter]="{isPosted:true,isPlanned:true}" [currentPlaTformsFilters]= "{isFacebookON: false, isLinkedinON: false, isGoogleON: true, isInstagramON: false}"/>
		</div>
	</div>
</div>
  
  